/**
 * Servicios de «Unidades» (antes «Tractores») y de la liga GPS ↔ unidad (ERP F1, B3 · D1 y D10).
 */

import api from './api.js';

const limpio = (params = {}) => {
  const out = {};
  Object.keys(params).forEach((k) => {
    if (params[k] !== '' && params[k] !== null && params[k] !== undefined && params[k] !== false) out[k] = params[k];
  });
  return out;
};

export const TIPOS = [
  ['tractor', 'Tractor'], ['implemento', 'Implemento'], ['dron', 'Dron'], ['vehiculo', 'Vehículo'], ['maquinaria_ligera', 'Maquinaria ligera']
];
export const ESTADOS = [
  ['por_llegar', 'Por llegar'], ['en_transito', 'En tránsito'], ['en_almacen', 'En almacén'], ['en_produccion', 'En producción'],
  ['liberado', 'Liberado'], ['en_consigna', 'En consigna'], ['vendido', 'Vendido'], ['entregado', 'Entregado'],
  ['en_servicio', 'En servicio'], ['recuperado', 'Recuperado'], ['baja', 'Baja']
];
export const ORIGENES = [['recepcion', 'Recepción'], ['gps', 'GPS (RedGPS)'], ['manual', 'Manual'], ['migracion', 'Migración (sin recepción)']];

const mapa = (pares) => Object.fromEntries(pares);
export const NOMBRE_TIPO = mapa(TIPOS);
export const NOMBRE_ESTADO = mapa(ESTADOS);
export const NOMBRE_ORIGEN = mapa(ORIGENES);
export const COLOR_ESTADO = {
  por_llegar: 'secondary', en_transito: 'secondary', en_almacen: 'info', en_produccion: 'warning', liberado: 'success',
  en_consigna: 'warning', vendido: 'primary', entregado: 'success', en_servicio: 'warning', recuperado: 'danger', baja: 'danger'
};

export default {
  resumen: () => api.get('/unidades/resumen'),
  listar: (params) => api.get('/unidades', limpio(params)),
  obtener: (numSerie) => api.get(`/unidades/${encodeURIComponent(numSerie)}`),
  actualizar: (numSerie, data) => api.put(`/unidades/${encodeURIComponent(numSerie)}`, data),
  gpsVehiculos: () => api.get('/unidades/gps/vehiculos'),
  ligarGps: (vehiculoId, unidadNumSerie) => api.put(`/unidades/gps/vehiculos/${vehiculoId}`, { unidad_num_serie: unidadNumSerie || null })
};
